import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getToken } from "services";
import { Policy } from "types";

type AuthStatus = "idle" | "loading" | "success" | "failed";
type SignInParams = { code: string; policy?: Policy };

type AuthState = {
  status: AuthStatus;
  token?: string;
};

const initialState: AuthState = {
  status: "idle",
  token: undefined,
};

const signIn = createAsyncThunk(
  "auth/signIn",
  ({ code, policy }: SignInParams) => getToken(code, policy)
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.token = undefined;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.status = "success";
    },
  },
  extraReducers(builder) {
    builder.addCase(signIn.pending, (state) => {
      state.status = "loading";
      state.token = undefined;
    });
    builder.addCase(signIn.fulfilled, (state, action) => {
      state.status = "success";
      state.token = action.payload;
    });
    builder.addCase(signIn.rejected, (state) => {
      state.status = "failed";
      state.token = undefined;
    });
  },
});

const { reset, setToken } = authSlice.actions;
const selectStatus = (state: { auth: AuthState }) => state.auth.status;
const selectToken = (state: { auth: AuthState }) => state.auth.token;

export { reset, setToken, signIn, selectStatus, selectToken };
export default authSlice.reducer;
